import { put } from "redux-saga/effects";
import { getIntegrationStatusesFailure, getIntegrationStatusesSuccess } from "../actionCreators";
import { GetIntegrationStatusesResponse } from "./../integration.service.d";
import { GetIntegrationStatusesRequestActionType } from "../types";
import { IntegrationService } from "../integration.service";

export function* getIntegrationStatusesSaga(action: GetIntegrationStatusesRequestActionType) {
    try {
        const { formId, method } = action.payload;
        const response: GetIntegrationStatusesResponse = yield IntegrationService.getIntegrationStatuses(formId, {
            method,
        });

        yield put(getIntegrationStatusesSuccess(response.data));
    } catch (error: any) {
        yield put(getIntegrationStatusesFailure(error?.response?.data || { message: error.message }));
    }
}
